<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="subsubgrouptypecategoryForm">
      <div class="">
        <h3 class="form_name">SubSubGroupTypeCategory</h3>


        <div class="input">
          <label for="">SubSubGroupTypeCategory Name</label>
          <input type="text" class="default_input reference-form" formControlName="SubSubGroupTypeCategoryName" />
        </div>


        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null"
            (click)="addNew(subsubgrouptypecategoryForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null"
            (click)="addNew(subsubgrouptypecategoryForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

        </div>

      </div>
    </form>
    <div class="display_table">
      <div class="search_container">
        <input type="text" class="default_input search" placeholder="Search for SubSubGroupTypeCategory"
          [formControl]="control" [appAutocomplete]="autocomplete" />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container *ngIf="(subsubgrouptypecategorys | filterReference: control.value) as result">
              <app-option (click)="selectSubSubGroupTypeCategory(option.id)" *ngFor="let option of result"
                [value]="option.SubSubGroupTypeCategoryName">
                {{ option.SubSubGroupTypeCategoryName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length">No result...</app-option>
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head">
        <span class="item">S/N</span>
        <span class="item">SubSubGroupTypeCategory Name</span>
        <span class="item">Action</span>

      </div>

      <div class="scroll">

      </div>
      <div class="body_content">
        <div class="the_body"
          *ngFor="let subsubgrouptypecategory of subsubgrouptypecategoryFormArray.get('SubSubGroupTypeCategorys')['controls']; index as i"
          (click)="onEdit(i, subsubgrouptypecategory.value)" style="cursor: pointer;" matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="content">{{i + 1}}</span>
          <span class="content">{{subsubgrouptypecategory.value.SubSubGroupTypeCategoryName}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button class="delete_icon trash" (click)="deleteSubSubGroupTypeCategory(i, subsubgrouptypecategory.value)">
              <em class="ti-trash"> </em> </button>
          </span>

        </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button"
          (click)="onSubmit(subsubgrouptypecategoryFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>
